import { SyntheticEvent } from 'react';
import { Body, Title } from 'atoms/Typography/Typography';
import { IAdaptedProduct } from 'commerce/scayle/utils/adapter/types';
import { useSiteConfig } from 'src/client/modules/shop/siteConfig/hooks';
import styles from './styles.module.css';

export const MaterialInfo = ({
  composedMaterials,
  onClick,
}: {
  composedMaterials: IAdaptedProduct['composedMaterials'];
  onClick?: (e: Event | SyntheticEvent<Element, Event>) => void;
}) => {
  const { materialInfo } = useSiteConfig();
  const content = materialInfo?.description?.content || [];

  const getText = (index: number) => content[index]?.content?.[0]?.text;

  return (
    <div onClick={onClick}>
      <Title type="md" className={styles.title}>
        {getText(0)}
      </Title>
      <Body type="md" className={styles.paragraph}>
        {getText(1)}
      </Body>
      <Body type="md" className={styles.paragraph}>
        {getText(2)}
        <strong>{composedMaterials?.value}</strong>
      </Body>
    </div>
  );
};
